"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = ProgressBar;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const getPercentage = (current, max) => Math.floor(Math.min((current / max) * 100, 100)) + "%";
const getFillStyle = ({ vertical = false, current, max, }) => vertical
    ? { height: getPercentage(current, max) }
    : { width: getPercentage(current, max) };
const useStyles = (0, react_jss_1.createUseStyles)({
    container: {
        width: "100%",
        height: "100%",
        position: "relative",
        background: "#636363",
        boxSizing: "border-box",
    },
    fill: (props) => (Object.assign({ position: "absolute", height: "100%", width: "100%", boxSizing: "border-box" }, getFillStyle(props))),
    contents: {
        position: "absolute",
        top: "0",
        right: "0.5em",
        fontWeight: 700,
        lineHeight: "1.75em",
    },
});
function ProgressBar(props) {
    const classes = useStyles(props);
    const { className, fillClassName = "", contentClassName = "", current, max, renderContents, children, } = props;
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.container, className) },
        React.createElement("div", { className: (0, classnames_1.default)(classes.fill, fillClassName) }),
        renderContents && (React.createElement("span", { className: (0, classnames_1.default)(classes.contents, contentClassName) }, renderContents(current, max))),
        children));
}
